import $ from 'jquery';

import Carousel from 'chairisher/component/carousel';
import BaseController from 'chairisher/_controller';
import ReviewsView from 'chairisher/view/reviews';

import { getMaxOffset, getPageSizes, getReviewPartnerUrl, getReviewUrl } from 'chairisher/context/review';

class ReviewsController extends BaseController {
    bindPageActions() {
        const reviewsView = new ReviewsView({
            maxOffset: getMaxOffset(),
            pageSizes: getPageSizes(),
            reviewsUrl: getReviewUrl(),
        });

        const $viewMoreButton = $('.js-view-more');
        $viewMoreButton.on('click', () => {
            reviewsView.getReviews().done(() => {
                if (!reviewsView.canFetchReviews()) {
                    const $viewMoreLink = $('<a></a>', {
                        href: getReviewPartnerUrl(),
                        target: '_blank',
                        text: $viewMoreButton.data('toggle-text'),
                    });
                    $viewMoreLink.insertAfter($viewMoreButton);
                    $viewMoreButton.remove();
                    $('.js-verified-reviews-logo').removeClass('hidden');
                }
            });
        });

        new Carousel({ $carousel: $('.js-carousel') }).bind();
        $viewMoreButton.trigger('click');
    }
}

export default ReviewsController;
